import Api from "@/services/Api";

export default {
  participantLogIn (params) {
    return Api().post("/participant-login", params);
  },
  updatePassword (params, token) {
    return Api().post("/change-password-one-participant", params, {
      headers: { "x-access-token": token }
    });
  },
};
